import { CompactType, DisplayGrid, GridsterConfig, GridType } from 'angular-gridster2';
import { PercentComponent } from './percent/percent.component';
import { CallQueueComponent } from './call-queue/call-queue.component';
import { UsersComponent } from './users/users.component';
import { LineChart } from '../shared/charts/line/line-chart';
import { Percent } from './percent/percent';
import { DashboardUsers } from './users/dashboard-users';
import { CallQueue } from './call-queue/call-queue';
import { Observable } from 'rxjs';
import { InboundCallsComponent } from './inbound-calls/inbound-calls.component';
import { OutboundCallsComponent } from './outbound-calls/outbound-calls.component';

export const dashboardOptions: GridsterConfig = {
  gridType: GridType.VerticalFixed,
  compactType: CompactType.None,
  margin: 16,
  outerMargin: false,
  outerMarginTop: null,
  outerMarginRight: null,
  outerMarginBottom: null,
  outerMarginLeft: null,
  mobileBreakpoint: 760,
  minCols: 1,
  maxCols: 100,
  minRows: 1,
  maxRows: 100,
  maxItemCols: 100,
  minItemCols: 1,
  maxItemRows: 100,
  minItemRows: 1,
  maxItemArea: 2500,
  minItemArea: 1,
  defaultItemCols: 1,
  defaultItemRows: 1,
  fixedRowHeight: 190,
  keepFixedHeightInMobile: true,
  keepFixedWidthInMobile: false,
  scrollSensitivity: 10,
  scrollSpeed: 20,
  enableEmptyCellClick: true,
  enableEmptyCellContextMenu: false,
  enableEmptyCellDrop: false,
  enableEmptyCellDrag: false,
  emptyCellDragMaxCols: 50,
  emptyCellDragMaxRows: 50,
  ignoreMarginInRow: false,
  draggable: {
    enabled: false
  },
  resizable: {
    enabled: false
  },
  swap: false,
  pushItems: true,
  disablePushOnDrag: false,
  disablePushOnResize: false,
  pushDirections: { north: true, east: true, south: true, west: true },
  pushResizeItems: false,
  displayGrid: DisplayGrid.OnDragAndResize,
  disableWindowResize: false,
  disableWarnings: false,
  scrollToNewItems: false
};

export enum dynamicComponent {
  InboundCallsComponent = 'InboundCallsComponent',
  OutboundCallsComponent = 'OutboundCallsComponent',
  PercentComponent = 'PercentComponent',
  CallQueueComponent = 'CallQueueComponent',
  UsersComponent = 'UsersComponent'
}

export const dynamicComponents = {
  [dynamicComponent.InboundCallsComponent]: InboundCallsComponent,
  [dynamicComponent.OutboundCallsComponent]: OutboundCallsComponent,
  [dynamicComponent.PercentComponent]: PercentComponent,
  [dynamicComponent.CallQueueComponent]: CallQueueComponent,
  [dynamicComponent.UsersComponent]: UsersComponent
};

export type dynamicComponentsInterfaces = LineChart | Percent | DashboardUsers[] | CallQueue[] | any;

export type dynamicComponentsObservableInterfaces = Observable<dynamicComponentsInterfaces>;

export const dynamicComponentsInputs = {
  [dynamicComponent.InboundCallsComponent]: <LineChart>{},
  [dynamicComponent.OutboundCallsComponent]: <LineChart>{},
  [dynamicComponent.PercentComponent]: <Percent>{
    value: 0,
    valueYesterday: 0
  },
  [dynamicComponent.CallQueueComponent]: <CallQueue[]>[],
  [dynamicComponent.UsersComponent]: <DashboardUsers[]>[]
};
